import React from 'react';
import { motion } from 'framer-motion';
import { Home, Search, Star, User, Heart, BookHeart, Moon } from 'lucide-react';

/**
 * BottomNav Component
 * active: "home" | "descopera" | "premium" | "profil" | "favorite"
 *
 * Standard glass: folosește preset-ul global `glass-nav`.
 * Orice ajustare de intensitate se face în index.css.
 */
const BottomNav = ({
  active,
  onNavigate,
  navItems,
  className = '',
  ...props
}) => {
  const iconMap = {
    nativus: Home,
    descopera: Search,
    premium: Star,
    profil: User,
    favorite: Heart,
    jurnal: BookHeart,
    somn: Moon,
  };

  const defaultNavItems = navItems || [
    { id: 'nativus', label: 'Nativus' },
    { id: 'somn', label: 'Somn' },
    { id: 'descopera', label: 'Explorează' },
    { id: 'premium', label: 'Premium' },
    { id: 'profil', label: 'Profil' },
  ];

  const itemsWithIcons = defaultNavItems.map(item => ({
    ...item,
    icon: iconMap[item.id] || Home,
  }));

  return (
    <nav
      className={`fixed left-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[600px] rounded-orb z-[1000] glass-nav ${className}`}
      style={{
        bottom: 'var(--bottom-nav-float)',
        paddingLeft: 'var(--bottom-nav-inner-pad-x, 1.5rem)',
        paddingRight: 'var(--bottom-nav-inner-pad-x, 1.5rem)',
        paddingTop: 'var(--bottom-nav-inner-pad-y, 0.65rem)',
        paddingBottom: 'var(--bottom-nav-inner-pad-y, 0.65rem)',
      }}
      {...props}
    >
      <div className="flex justify-between items-center relative z-10 w-full">
        {itemsWithIcons.map((item) => {
          const isActive = active === item.id;
          const Icon = item.icon;
          return (
            <motion.button
              key={item.id}
              className="flex-1 flex flex-col items-center justify-center gap-[0.15rem] rounded-card border-0 bg-transparent cursor-pointer transition-all duration-premium ease-premium"
              style={{
                padding: '0.35rem 0.25rem',
                color: isActive ? '#2F3A2D' : 'rgba(47,58,45,0.82)',
                background: isActive ? 'rgba(95,115,92,0.20)' : 'transparent',
              }}
              onClick={() => onNavigate(item.id)}
              whileHover={{ background: 'rgba(95,115,92,0.14)' }}
              whileTap={{ scale: 0.95 }}
              transition={{ duration: 0.22, ease: [0.2, 0.8, 0.2, 1] }}
            >
              <Icon size={22} strokeWidth={2} />
              <span style={{ fontSize: '0.7rem', fontWeight: isActive ? 600 : 400 }}>
                {item.label}
              </span>
            </motion.button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
